<template>
    <!-- DESCRIPTION CARD --> 
    <div class="bg-white cursor-pointer flex overflow-hidden shadow-md justify-between border px-6 py-3 mb-4 rounded-lg -mt-3">
        <div class="flex flex-col w-4/5 justify-center">
            <p class="uppercase font-semibold mb-1 text-gray-700">Package Description</p>
            <p class="text-sm text-gray-700">{{briefData.description}}</p>
        </div>
        <div :class="`image-container ${briefData.imageColor}`">
            <img :src="require(`@/assets/images/${briefData.image}`)" class="max-w-12">
        </div>
    </div>
    <!-- TECHNOLOGY ASSETS REPOSITORY -->
    <FunnelCard :brief-data="briefData" />
   
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
import FunnelCard from './FunnelCard.vue';

defineProps(['briefData']);

</script>
<style lang="scss" scoped>
.image-container {
    height: 100px;
    width: 100px;
}
.number {
    background: rgb(255 255 255 / 25%);
    padding: 0.5rem;
    border-radius: 50%;
    width: 33px;
    text-align: center;
    height: 33px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.5rem;
}

.filter-box {
    color: $moss;

    .filter-title {
        line-height: 1.2;

        .title {
            text-transform: uppercase;
            font-weight: 500;
            margin-bottom: 0;
        }

        .subtitle {
            font-size: 0.8rem;
            font-weight: 300;
        }
    }

    .filter-numbers {
        border-top: 1px solid white;

        p:last-child {
            border: none;
        }

        p {
            position: relative;
            padding: 0.8rem 0.5rem;
            font-size: 1.2rem;
            border-right: 1px solid white;

            span.otr {
                position: absolute;
                top: 50%;
                left: 16px;
                transform: translate(0%, -50%);
                font-weight: 400;
                color: rgba(255, 255, 255, 0.5);
                font-size: 1.7rem;

                &.final {
                    position: relative;
                    top: auto;
                    left: auto;
                    transform: none;
                }
            }
        }
    }

    .filter-options {
        border-top: 1px solid white;

        .filter-option {
            margin-bottom: 0.5rem;
            font-size: 1rem;

            input {
                width: 14px;
                height: 14px;
                border-radius: 5px;
                margin-right: 0.3rem;

                &:checked {
                    background-image: url("@/assets/icons/black-check-box.svg");
                }
            }

            label {
                display: inline-flex;
                font-size: 0.85rem;
                cursor: pointer;
                margin-right: 0.8rem;
            }
        }
    }

    .no-stroke {
        stroke: none;
    }

    .chart-icon {
        border-radius: 50%;
        border: 2px solid white;
        position: absolute;
        padding: 6px;
        top: -30px;
        right: 17px;

        svg {
            stroke: none;
            color: white;
        }

    }
}

.spin-chart {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    stroke: none;
    color: $acqua;
    color: #e9f1eb;
    width: 6rem;
    height: 6rem;

    &.hs {
        color: $peach-light;
    }

    &.heat {
        color: $nude;
    }
}
</style>